import { MouseEventHandler, ReactNode } from 'react';

import { ButtonBase } from '@mui/material';

interface WrapperProps {
  className?: string;
  children?: ReactNode;
  onClick?: MouseEventHandler;
}

const Wrapper = ({ className, children, onClick }: WrapperProps) => {
  if (onClick) {
    return (
      <ButtonBase focusRipple className={className} onClick={onClick}>
        {children}
      </ButtonBase>
    );
  }

  return <div className={className}>{children}</div>;
};

export default Wrapper;
